import { render, staticRenderFns } from "./GeneralProcess.vue?vue&type=template&id=dc75c56c&"
import script from "./GeneralProcess.vue?vue&type=script&lang=js&"
export * from "./GeneralProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports